export function maskPhone(phone) {
    if(!phone) return phone;
    let phoneFormatted = `(${phone.slice(2,4)}) ${phone.slice(4)}`;
    return phoneFormatted;
}